import React, {FC} from 'react';
import {Drop} from '../../../../grpc_client/grips/protos/shared/drop';
import {useDropsTranslationContext} from '../../../../pages/Drops/context/TranslationProvider';
import {SectionTrackingContextProvider} from '../../../../tracking/context/SectionTrackingContext';
import {
  SectionSeparator,
  SeparatorCategory,
  SeparatorTitle,
  TeaserContainer,
} from '../DropOverviewStyles';
import {ActiveDrop} from './ActiveDrop';
export const ActiveDrops: FC<{
  activeDrops: Drop[];
}> = ({activeDrops}) => {
  const translations = useDropsTranslationContext();
  if (activeDrops.length === 0) {
    return null;
  }

  return (
    <>
      <SectionSeparator>
        <SeparatorCategory>
          {translations.overview.sections.active.subHeadline}
        </SeparatorCategory>
        <SeparatorTitle>
          {translations.overview.sections.active.headline}
        </SeparatorTitle>
      </SectionSeparator>
      <TeaserContainer>
        <SectionTrackingContextProvider>
          {activeDrops.map(drop => (
            <ActiveDrop key={drop.id} drop={drop} />
          ))}
        </SectionTrackingContextProvider>
      </TeaserContainer>
    </>
  );
};
